import { getDocumentExtension } from '@helpers/document-info';
import useAuth from '@hooks/use-auth';
import useMedia, { downloadToLocalObject } from '@hooks/use-media';
import type { ApiDocument } from '@interfaces/messages';
import File from '@pages/components/File';
import type { FC } from 'react';
import { useCallback } from 'react';

import styles from './Document.module.scss';

interface OwnProps {
  id: number;
  document: ApiDocument;
}

const Document: FC<OwnProps> = ({ id, document: apiDocument }) => {
  const auth = useAuth();
  const thumbnailUrl = useMedia(id, apiDocument.thumbnail !== undefined, apiDocument.thumbnail?.file_id);

  const onDownload = useCallback(async () => {
    const url = `${import.meta.env.VITE_API_URL}/message/${id}/media`;
    const localBlobUrl = await downloadToLocalObject(auth, url);
    const anchor = document.createElement('a');
    anchor.href = localBlobUrl;
    if (apiDocument.file_name) {
      anchor.download = apiDocument.file_name;
    }
    anchor.dispatchEvent(new MouseEvent('click'));
    setTimeout(() => {
      URL.revokeObjectURL(localBlobUrl);
      anchor.remove();
    }, 100);
  }, [id, apiDocument, auth]);

  const name = apiDocument.file_name || 'Unknown';

  return (
    <div className={styles.document}>
      <File
        name={name}
        extension={getDocumentExtension(apiDocument)}
        size={apiDocument.file_size}
        previewData={thumbnailUrl}
        onDownloadClick={onDownload}
        file_id={apiDocument.file_id}
      />
    </div>
  );
};

export default Document;
